import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import { LINKS } from '@/constants/links';
import React from 'react';
import { SectionHeadline } from '@/components/SectionHeadline';
import { FAQs } from '@/components/seo';
import { Link } from '@/components/links';
export function Faqs() {
  const $ = _c(61);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["mallpay"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("questions.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mb-12 lg:mb-16" anchorKey="questions.title" id="faq">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("questions.items.1.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("questions.items.1.text");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = {
      question: t3,
      answer: t4
    };
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("questions.items.2.title");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Link to={LINKS().card} testId="mallpayCard" analyticsParam="mallpayCard" />;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = <Trans t={t} i18nKey="questions.items.2.text">{t7}</Trans>;
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = {
      question: t6,
      answer: t8
    };
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("questions.items.3.title");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Link to={LINKS().whereToShop} testId="mallpayWhereToShop" analyticsParam="mallpayWhereToShop" />;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Link to={LINKS().card} testId="mallpayCard" analyticsParam="mallpayCard" />;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t) {
    t13 = <Trans t={t} i18nKey="questions.items.3.text">{t11}{t12}</Trans>;
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t10 || $[27] !== t13) {
    t14 = {
      question: t10,
      answer: t13
    };
    $[26] = t10;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t("questions.items.4.title");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t) {
    t16 = t("questions.items.4.text");
    $[31] = t;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t15 || $[34] !== t16) {
    t17 = {
      question: t15,
      answer: t16
    };
    $[33] = t15;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t) {
    t18 = t("questions.items.5.title");
    $[36] = t;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Link to={LINKS().registration} testId="mallpayRegistration" analyticsParam="mallpayRegistration" />;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t) {
    t20 = <Trans t={t} i18nKey="questions.items.5.text">{t19}</Trans>;
    $[39] = t;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t18 || $[42] !== t20) {
    t21 = {
      question: t18,
      answer: t20
    };
    $[41] = t18;
    $[42] = t20;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t) {
    t22 = t("questions.items.6.title");
    $[44] = t;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t) {
    t23 = t("questions.items.6.text");
    $[46] = t;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t22 || $[49] !== t23) {
    t24 = {
      question: t22,
      answer: t23
    };
    $[48] = t22;
    $[49] = t23;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t14 || $[52] !== t17 || $[53] !== t21 || $[54] !== t24 || $[55] !== t5 || $[56] !== t9) {
    t25 = <div className="mx-auto flex max-w-192 flex-col gap-2"><FAQs hideButton={true} className="m-0!" data={[t5, t9, t14, t17, t21, t24]} /></div>;
    $[51] = t14;
    $[52] = t17;
    $[53] = t21;
    $[54] = t24;
    $[55] = t5;
    $[56] = t9;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== t2 || $[59] !== t25) {
    t26 = <div className="px-4">{t2}{t25}</div>;
    $[58] = t2;
    $[59] = t25;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  return t26;
}